import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

/**
 * Renders its children only for a user who may manage accounts — STAFF (all contractors)
 * or a subco ADMIN (its own). Otherwise redirects to the dashboard. Defense-in-depth for
 * the account-management screen (G2-1b/1c): the nav already hides it and the API enforces
 * the same gate server-side, but this stops a TECH from reaching it by typing the URL.
 * Assumes it sits inside ProtectedRoute (the user is already authenticated).
 */
export function UserManagerGuard({ children }: { children: ReactNode }) {
  const { canManageUsers } = useAuth();
  if (!canManageUsers) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
